import { render, staticRenderFns } from "./BucketListForm.vue?vue&type=template&id=629bf0fb&"
import script from "./BucketListForm.vue?vue&type=script&lang=js&"
export * from "./BucketListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports